"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "bg-mutedpurple-800 h-[7.5rem] zigzag-bottom zigzag-mutedpurple-800 mb-16" }, null, -1);
const _hoisted_2 = { class: "flex justify-center items-center px-5 md:px-10" };
const _hoisted_3 = { class: "w-full max-w-[1160px]" };
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h1", { class: "uppercase text-3xl sm:text-6xl font-black mb-10" }, "Journal", -1);
const BlogPostList_vue_1 = __importDefault(require("./BlogPostList.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'BlogIndex',
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                _hoisted_1,
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        _hoisted_4,
                        (0, vue_2.createVNode)(BlogPostList_vue_1.default)
                    ])
                ])
            ]));
        };
    }
});
